// extracted by mini-css-extract-plugin
export default {"changeLink":"UQ-z","disabled":"VQ-z","inline":"WQ-z"};